export default "__VITE_ASSET__ab0f890d__"